module.exports = __webpack_public_path__ + "static/media/nytimes.com_2016_05_29_opinion_sunday_why-you-will-marry-the-wrong-person.html_plot.a71e2657.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nytimes.com_2016_05_29_opinion_sunday_why-you-will-marry-the-wrong-person.html_plot.png
// module id = 407
// module chunks = 0